
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import monitoring from './utils/monitoring';
import './tracing';

monitoring.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
